import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { updatePriority } from '../../common/constants/api';
import { navigate } from 'gatsby';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import Toast from '../../common/components/Toast/Toast';
import {
  removeApplicantionInfo,
  setApplicantionInfo
} from '../../common/utils/applicantionInfo';
import Modal from '../../common/components/Modal/modal';
import AssignOwner from '../../containers/RMDashboard/AssignOwner';
import AssignTargetMonth from '../../containers/RMDashboard/AssignTargetMonth';
import { getAcl } from '../../common/utils/acl-utils';
import PopUp from '../../common/components/PopUp/PopUp';

export const numberFormat = number => {
  if (!isNaN(number) && number) {
    let num;
    try {
      num = number
        .toFixed(1)
        .replace(/(\d)(?=(\d{2})+\d\.)/g, '$1,')
        .toString()
        .split('.')[0];
    } catch {
      num = number;
    }
    return num;
  }
  return number;
};
export const DateFormat = date => {
  if (date && moment(date).isValid()) {
    return moment(date).format('DD-MM-YYYY');
  }
  return date;
};
typeof document === 'undefined'
  ? ''
  : document.addEventListener(
      'click',
      function() {
        priorityFocusOut();
      },
      false
    );
let previousTarget = '';
let previousTargetParent = '';
const priorityChange = () => props => {
  // console.log('PP change');
  previousTarget !== '' ? (previousTarget.style.display = 'none') : null;
  previousTargetParent !== ''
    ? previousTargetParent.classList.remove('priority-highlighted')
    : null;
  let target = props.currentTarget.getElementsByClassName('priority-menu')[0];
  target.parentElement.classList.add('priority-highlighted');
  target.style.display = 'block';
  previousTarget = target;
  previousTargetParent = target.parentElement;
  props.preventDefault();
  props.stopPropagation();
  props.nativeEvent.stopImmediatePropagation();
};
const prioritySelected = (status, leadId) => props => {
  let target = props.currentTarget;
  target.parentElement.style.display = 'none';
  target.parentElement.parentElement.classList.remove('priority-highlighted');
  let container = target.parentElement.parentElement.getElementsByClassName(
    'priority-container'
  )[0];
  if (status == 'Low')
    container.innerHTML =
      '<p class="text-green-500 float-left" style="font-weight: 900; font-size: 14px "> &#8595;</p><span class="ml-2">Low</span>';
  else if (status === 'Medium')
    container.innerHTML =
      '<p class="text-orange-200 float-left" style="font-weight: 900; font-size: 14px "> &#8593;</p><span class="ml-2">Medium</span>';
  else
    container.innerHTML =
      '<p class="text-red-200 float-left" style="font-weight: 900; font-size: 14px "> &#8593;</p><span class="ml-2">High</span>';
  updatePriority(leadId, status).then(res => console.log(res));
  props.stopPropagation();
  props.preventDefault();
};
const priorityFocusOut = () => {
  previousTarget !== '' ? (previousTarget.style.display = 'none') : null;
  previousTargetParent !== ''
    ? previousTargetParent.classList.remove('priority-highlighted')
    : null;
};
const handleRowClick = async row => {
  if (row.status == 'Follow Up' || row.status == 'Not Interested') {
    navigate(`/app/addlead?leadId=${row.leadId}`);
  } else {
    let applicationInfo = {
      leadId: row.leadId,
      leadApplicantId: row.applicantId,
      applicationStatus: row.status,
      leadData: {
        leadApplicantPhone: row?.phoneNumber || '-',
        leadId: row?.leadId || '-',
        leadName: row?.name || '-',
        loanAmount: row?.loanAmount || '-',
        loanProduct: row?.product || '-',
        propertyCity: row?.city || '-'
      }
    };
    removeApplicantionInfo();
    await setApplicantionInfo(applicationInfo);
    let leadProductInfo = {
      leadProduct: row?.product,
      leadSubProduct: row?.subProduct
    };
    localStorage.setItem('leadProductInfo', JSON.stringify(leadProductInfo));
    navigate(`/app/leadprofile`);
  }
};
const commonStyle = 'font-roboto font-normal text-center mx-auto table_font';
const commonHeaderStyle = `text-center mx-auto ml-2 font-medium`;

const ShowAssignModal = ({
  row,
  setOwnerName,
  setShowReassign,
  showOwnerName
}) => {
  let firstName = '',
    middleName = '',
    lastName = '',
    ownerFirstName = '',
    ownerMdName = '',
    ownerlstName = '';
  if (typeof row?.name?.firstName == 'string') firstName = row.name.firstName;
  if (typeof row?.name?.middleName == 'string')
    middleName = row.name.middleName;
  if (typeof row?.name?.lastName == 'string') lastName = row.name.lastName;

  return (
    <AssignOwner
      leadId={row?.leadId}
      name={`${firstName} ${middleName} ${lastName}`}
      ownerName={`${showOwnerName}`}
      row={row}
      setOwnerName={setOwnerName}
      setShowReassign={setShowReassign}
    />
  );
};
const ShowTargetMonthModal = ({
  row,
  setShowReassignMonth,
  settargetMonth,
  showMonth,
  ReassignTargetMonth
}) => {
  let firstName = '',
    middleName = '',
    lastName = '';
  if (typeof row?.name?.firstName == 'string') firstName = row.name.firstName;
  if (typeof row?.name?.middleName == 'string')
    middleName = row.name.middleName;
  if (typeof row?.name?.lastName == 'string') lastName = row.name.lastName;

  return (
    <AssignTargetMonth
      leadId={row?.leadId}
      name={`${firstName} ${middleName} ${lastName}`}
      row={row}
      setShowReassignMonth={setShowReassignMonth}
      settargetMonth={`${settargetMonth}`}
      showMonth={showMonth}
      ReassignTargetMonth={ReassignTargetMonth}
    />
  );
};

const Columns = [
  {
    name: <span className={`${commonHeaderStyle}`}>Priority</span>,
    selector: 'priority',
    sortable: true,
    cell: row => (
      <div
        className="flex items-center priority cursor-pointer"
        onClick={priorityChange()}
      >
        <div className="priority-container w-100">
          {row.priority == 'High' ? (
            <p
              className="text-red-100 float-left"
              style={{ fontWeight: '900', fontSize: '14px' }}
            >
              &#8593;
            </p>
          ) : row.priority == 'Low' ? (
            <p
              className="text-green-500 float-left"
              style={{ fontWeight: '900', fontSize: '14px' }}
            >
              &#8595;
            </p>
          ) : row.priority == 'Medium' ? (
            <p
              className="text-orange-200 float-left"
              style={{ fontWeight: '900', fontSize: '14px' }}
            >
              &#8593;
            </p>
          ) : null}
          <span className="ml-2">{row.priority}</span>
        </div>
        <ul className="priority-menu shadow">
          <li className="high" onClick={prioritySelected('High', row.leadId)}>
            <p
              className="text-red-100 float-left px-1"
              style={{ fontWeight: '900', fontSize: '14px' }}
            >
              &#8593;
            </p>
            High
          </li>
          <li
            className="medium"
            onClick={prioritySelected('Medium', row.leadId)}
          >
            <p
              className="text-orange-200 float-left px-1"
              style={{ fontWeight: '900', fontSize: '14px' }}
            >
              &#8593;
            </p>
            Mediun
          </li>
          <li className="low" onClick={prioritySelected('Low', row.leadId)}>
            <p
              className="text-green-500 float-left px-1"
              style={{ fontWeight: '900', fontSize: '14px' }}
            >
              &#8595;
            </p>
            Low
          </li>
        </ul>
      </div>
    )
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Customer Name</p>,
    selector: 'name',
    sortable: true,
    cell: row => {
      let firstName = '',
        middleName = '',
        lastName = '';
      if (row.name.firstName) {
        firstName =
          row.name.firstName.charAt(0).toUpperCase() +
          row.name.firstName.substr(1).toLowerCase() +
          ' ';
      }
      if (row.name.middleName) {
        middleName = row.name.middleName.toString() + ' ';
      }
      if (row.name.firstName) {
        lastName = row.name.lastName.toString();
      }
      return (
        <div className="w-full mx-auto text-center">
          <p
            className={`text-center whitespace-pre ${commonStyle}`}
            style={{ whiteSpace: 'break-spaces' }}
          >
            {firstName + middleName + lastName}
          </p>
        </div>
      );
    },
    minWidth: '130px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Lead ID</p>,
    selector: 'leadId',
    sortable: true,
    cell: row => (
      <div className={`w-full mx-auto text-center ${commonStyle}`}>
        <p
          className="text-center whitespace-pre"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.leadId}
        </p>
      </div>
    )
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Sourcing Date</p>,
    selector: 'sourcingDate',
    sortable: true,
    cell: row => (
      <div className={`w-full mx-auto text-center ${commonStyle}`}>
        <p
          className="text-center whitespace-pre"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {DateFormat(row.sourcingDate)}
          <p className="-ml-2">
            {row.sourcingDate && moment(row.sourcingDate).format('hh:mm A')}
          </p>
        </p>
      </div>
    ),
    minWidth: '100px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Status</p>,
    selector: 'status',
    sortable: true,
    cell: row => {
      let styleContainer, classcontainer;
      if (
        row.status == 'New Lead' ||
        row.status == 'closed' ||
        row.status == 'Sanctioned'
      ) {
        classcontainer =
          'text-green-600 items-center py-2  px-1 rounded font-roboto font-sm mx-auto';
        styleContainer = { backgroundColor: '#a1f5a8' };
      } else if (row.status == 'Document Pending') {
        classcontainer =
          'text-orange-600 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#ffdec1', fontSize: '11px' };
      } else if (row.status == 'Login') {
        classcontainer =
          'text-orange-600 items-center py-2  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = {
          backgroundColor: '#fff1e5',
          fontSize: '11px'
        };
      } else if (row.status == 'Follow Up') {
        classcontainer =
          'text-blue-500 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = {
          backgroundColor: '#aebae4',
          fontSize: '11px'
        };
      } else if (row.status == 'Not Interested') {
        classcontainer =
          'text-red-100 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = {
          backgroundColor: '#ffdec1',
          fontSize: '11px'
        };
      } else if (row.status == 'BP Raised') {
        classcontainer =
          'text-blue-500 items-center py-2  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#aebae4' };
      } else if ((row.status == 'Disbursed') | (row.status == 'Open')) {
        classcontainer =
          'text-blue-500 items-center py-2  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#aebae4' };
      } else if (row.status == 'In Principle Pending') {
        classcontainer =
          'text-red-100 items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#f7e5e7' };
      } else if (
        row.status == 'In Principle Accepted' ||
        row.status == 'Interested'
      ) {
        classcontainer =
          'text-white items-center py-1  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#00ACB8' };
      } else if (row.status == 'Rejected' || row.status == 'Lead Rejected') {
        classcontainer =
          'text-white items-center py-2  px-2 rounded font-roboto font-xs mx-auto';
        styleContainer = { backgroundColor: '#ff5464' };
      }

      let a = document.getElementsByClassName('status');
      return (
        <div
          className="flex items-center cursor-pointer w-full "
          onClick={() => handleRowClick(row)}
        >
          <div
            className={classcontainer + ' status w-full'}
            style={styleContainer}
          >
            <p
              className={`${commonStyle}`}
              style={{ whiteSpace: 'break-spaces' }}
            >
              {row.status == 'New Lead' ? 'Lead' : row.status}
            </p>
          </div>
        </div>
      );
    },
    minWidth: '80px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Product</p>,
    selector: 'product',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.product ? row.product : <span>&#8212;</span>}
        </p>
      </div>
    )
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Sub Product</p>,
    selector: 'subProduct',
    sortable: true,
    cell: row => (
      <div className={`w-full mx-auto text-center ${commonStyle}`}>
        <p
          className="text-center whitespace-pre"
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.subProduct ? row.subProduct : <span>&#8212; </span>}
        </p>
      </div>
    ),
    minWidth: '100px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>RM</p>,
    selector: 'rmName',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.rmName && row.rmName?.firstName != null ? (
            `${row.rmName?.firstName ? row.rmName?.firstName : ''} ${
              row.rmName?.middleName ? row.rmName?.middleName : ''
            } ${row.rmName?.lastName ? row.rmName?.lastName : ''}`
          ) : (
            <span>&#8212; </span>
          )}
        </p>
      </div>
    ),
    minWidth: '120px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Source</p>,
    selector: 'source',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.source ? row.source : <span>&#8212; </span>}
        </p>
      </div>
    )
  },
  {
    name: <p className={`${commonHeaderStyle} w-full`}>Current Owner</p>,
    selector: 'Current Owner',
    sortable: true,
    cell: row => {
      let ownerFirstName = '',
        ownerMdName = '',
        ownerlstName = '';

      const [show, setShow] = useState(false);
      const [showNotAllowed, setShowNotAllowed] = useState(false);
      const [showReassign, setShowReassign] = useState(false);

      const [showOwnerName, setOwnerName] = useState(
        `${ownerFirstName} ${ownerMdName} ${ownerlstName}`
      );

      const isAthorisedToReassign = getAcl()?.acl?.can_reassign_leads;
      const handleClick = () => {
        setShowReassign(true);
        setShowNotAllowed(true);
      };

      useEffect(() => {
        if (typeof row?.ownerName?.firstName == 'string')
          ownerFirstName = row.ownerName.firstName;
        if (typeof row?.ownerName?.middleName == 'string')
          ownerMdName = row.ownerName.middleName;
        if (typeof row?.ownerName?.lastName == 'string')
          ownerlstName = row.ownerName.lastName;
        setOwnerName(`${ownerFirstName} ${ownerMdName} ${ownerlstName}`);
      }, [row?.ownerUserId]);

      return (
        <div
          className={`w-full mx-auto text-center ${
            isAthorisedToReassign ? 'cursor-pointer ' : ''
          }`}
          onClick={() => (isAthorisedToReassign ? handleClick() : null)}
        >
          {showReassign ? (
            <ShowAssignModal
              row={row}
              setOwnerName={setOwnerName}
              setShowReassign={setShowReassign}
              showOwnerName={showOwnerName}
            />
          ) : null}
          <p
            className={`text-center whitespace-pre ${commonStyle} ${
              isAthorisedToReassign ? 'text-blue-600 text-center' : ''
            }`}
            style={{ whiteSpace: 'break-spaces', fontWeight: 400 }}
          >
            {showOwnerName ? `${showOwnerName}` : <span>&#8212; </span>}
          </p>
        </div>
      );
    },
    minWidth: '100px !important'
  },
  {
    name: <p className={`${commonHeaderStyle} w-full`}>Target Month</p>,
    selector: 'targetMonth',
    sortable: true,
    cell: row => {
      const [show, setShow] = useState(false);
      const [showNotAllowedEdit, setShowNotAllowedEdit] = useState(false);
      const [ReassignTargetMonth, setShowReassignMonth] = useState(false);
      const [settargetMonth, showMonth] = useState(row.targetMonth);
      const isAuthorisedToEditTargetMonth = getAcl()?.acl?.can_set_target_month;
      const handleClickEditMonth = () => {
        setShowReassignMonth(true);
        setShowNotAllowedEdit(true);
      };

      useEffect(() => {
        showMonth(row?.targetMonth);
      }, [row?.targetMonth]);

      return (
        <div
          className={`w-full mx-auto text-center ${
            isAuthorisedToEditTargetMonth ? 'cursor-pointer ' : ''
          }`}
          onClick={() =>
            isAuthorisedToEditTargetMonth ? handleClickEditMonth() : null
          }
        >
          {ReassignTargetMonth ? (
            <ShowTargetMonthModal
              row={row}
              setShowReassignMonth={setShowReassignMonth}
              settargetMonth={settargetMonth}
              showMonth={showMonth}
              ReassignTargetMonth={ReassignTargetMonth}
            />
          ) : null}
          <p
            className={`text-center whitespace-pre ${commonStyle} ${
              isAuthorisedToEditTargetMonth ? 'text-blue-600 text-center' : ''
            }`}
            style={{ whiteSpace: 'break-spaces', fontWeight: 400 }}
          >
            {settargetMonth ? (
              moment(settargetMonth).format('MMM YYYY')
            ) : (
              <span>&#8212; </span>
            )}
          </p>
        </div>
      );
    },
    minWidth: '100px !important'
  },

  {
    name: <p className={`${commonHeaderStyle}`}>City</p>,
    selector: 'city',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.city ? row.city : <span>&#8212; </span>}
        </p>
      </div>
    ),
    minWidth: '100px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Loan Amount</p>,
    selector: 'loanAmount',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377; {numberFormat(row.loanAmount ? row.loanAmount : 0)}
        </p>
      </div>
    ),
    minWidth: '90px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Login Amount</p>,
    selector: 'loginAmount',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377;{numberFormat(row?.loginAmount ? row?.loginAmount : '0')}
        </p>
      </div>
    ),
    minWidth: '90px !important'
  },

  {
    name: <p className={`${commonHeaderStyle}`}>Login Date</p>,
    selector: 'loginDate',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row?.loginDate ? DateFormat(row?.loginDate) : 'NA'}
          <p className="-ml-2">
            {row?.loginDate && moment(row?.loginDate).format('hh:mm A')}
          </p>
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Sanction Amount</p>,
    selector: 'finalSanctionAmount',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377;
          {numberFormat(
            row?.finalSanctionAmount ? row?.finalSanctionAmount : 0
          )}
        </p>
      </div>
    ),
    minWidth: '90px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Sanction Date</p>,
    selector: 'finalSanctionDate',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row?.finalSanctionDate ? DateFormat(row?.finalSanctionDate) : 'NA'}
          <p className="-ml-2">
            {row?.finalSanctionDate &&
              moment(row?.finalSanctionDate).format('hh:mm A')}
          </p>
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Disbursed Amount</p>,
    selector: 'disbursedAmount',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          &#8377; &nbsp;
          {numberFormat(row.disbursedAmount ? row.disbursedAmount : 0)}
        </p>
      </div>
    ),
    minWidth: '90px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Disbursed Date</p>,
    selector: 'disbursedtDate',

    sortable: true,
    cell: row => (
      <div className="w-full mx-auto ">
        <p
          className={` whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row?.disbursedDate ? DateFormat(row?.disbursedDate) : 'NA'}
          <p className="-ml-2">
            {row?.disbursedDate && moment(row?.disbursedDate).format('hh:mm A')}
          </p>
        </p>
      </div>
    ),
    minWidth: '70px !important'
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Bank</p>,
    selector: 'bankName',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {row.bankName ? row.bankName : <span>&#8212; </span>}
        </p>
      </div>
    )
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Payout</p>,
    selector: 'payout',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {' '}
          &#8377; &nbsp;{numberFormat(row.payout ? row.payout : 0)}
        </p>
      </div>
    )
  },
  {
    name: <p className={`${commonHeaderStyle}`}>DOC Pending</p>,
    selector: 'doc_pending',
    sortable: true,
    cell: row => {
      return (
        <div
          className={`text-red-400 px-3 py-1  mx-auto ${commonStyle}`}
          style={{ backgroundColor: '#F7E5E7', borderRadius: '7px' }}
        >
          {row.doc_pending ? row.doc_pending : 0}
        </div>
      );
    }
  },
  {
    name: <p className={`${commonHeaderStyle}`}>Last Action Date</p>,
    selector: 'lastActionDate',
    sortable: true,
    cell: row => (
      <div className="w-full mx-auto text-center">
        <p
          className={`text-center whitespace-pre ${commonStyle}`}
          style={{ whiteSpace: 'break-spaces' }}
        >
          {DateFormat(row.lastActionDate)}
          <p className="-ml-2">
            {row.lastActionDate && moment(row.lastActionDate).format('hh:mm A')}
          </p>
        </p>
      </div>
    ),
    minWidth: '70px !important'
  }
];

export default Columns;
